import { IDonorCompliance } from '@nkr/models/index';
import { TableWrapperLeftAligned } from './styles';
import ReactHtmlParser from 'react-html-parser';

interface IProps {
    list: IDonorCompliance[],
    centerId: number,
    isPostTransplant: boolean
}

const DonorCompliance = (props: IProps) => {

    const keywordsdata = [
        { key: 'relationship',  value: '/donor-data' },
        { key: 'UNOS',          value: '/donor-data' },
        { key: 'HLA',           value: '/hla-info' },
        { key: 'kidney',        value: '/post-transplant' },
        { key: 'Race',          value: '/medical-details' },
        { key: 'Gender',        value: '/medical-details' },
        { key: 'bifurcation',   value: '/medical-details' },
        { key: 'evaluation',    value: '/medical-details' },
        { key: 'pressure',      value: '/medical-details' },
        { key: 'smoking',       value: '/medical-details' }
      ];

      const getUrl = (isPostTransplant: boolean, descriptions: string[]) => {
        if(descriptions.length < 1 || isPostTransplant == true)
            return '/post-transplant';

        const item = keywordsdata.find(entry => descriptions[0].indexOf(entry.key) !== -1);
        return (item ? item.value : '');
      }

    return (
        <div style={{ height: 500, overflowY: 'scroll' }}>
            <TableWrapperLeftAligned className='table table-condensed table-striped table-bordered'>
                <thead>
                    <tr>
                        <th style={{ position: 'sticky', top: 0 }}>Donor</th>
                        <th style={{ position: 'sticky', top: 0 }}>Item</th>
                    </tr>
                </thead>
                <tbody>
                    {props.list.map((item, index) => {                       
                        let url = `/center/${props.centerId}/donor/${item.id}/profile`;
                        url += getUrl(props.isPostTransplant, item.complianceIssues);                        

                        return (
                            <tr key={index}>
                                <td>
                                    <a href={url} target='_blank'>{item.alias != '' ? item.alias : '[Missing Alias]'}</a>
                                </td>
                                <td>
                                    {item.complianceIssues.map((issue, index) =>
                                        <div key={index}>{ReactHtmlParser(issue)}</div>
                                    )}
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </TableWrapperLeftAligned>
        </div>
    );
}

export default DonorCompliance;